// src/components/VolunteerUpdatePassword.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchJSON } from '../api';

const VolunteerUpdatePassword = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('volunteer'));
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      // Use fetchJSON with the volunteer's id for updating password.
      await fetchJSON(`/api/users/${user._id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          password: currentPassword,
          newPassword,
          reset: false
        })
      });
      alert('Password updated successfully');
      user.firstTime = false;
      localStorage.setItem('volunteer', JSON.stringify(user));
      navigate('/volunteer/dashboard');
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl mb-4">Update Your Password</h2>
      <form onSubmit={handleSubmit} className="max-w-md">
        <div className="mb-4">
          <label>Current Password:</label>
          <input
            type="password"
            value={currentPassword}
            onChange={e => setCurrentPassword(e.target.value)}
            className="w-full border p-2 rounded"
            required
          />
        </div>
        <div className="mb-4">
          <label>New Password:</label>
          <input
            type="password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            className="w-full border p-2 rounded"
            required
          />
        </div>
        <button type="submit" className="bg-primary text-white px-4 py-2 rounded">
          Change
        </button>
      </form>
    </div>
  );
};

export default VolunteerUpdatePassword;
